<template>
    <section class="flex-column">
        <!-- CIVILITY -->
        <el-form-item prop="civility" :label="$t.__('common.labels.civility')">
            <el-select v-model="civility" class="wp-10">
                <el-option
                    v-for="option in civilities"
                    :key="option.value"
                    :value="option"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>

        <!-- NAME -->
        <el-form-item prop="name" :label="$t.__('common.labels.name')">
            <el-input name="lastname" autocomplete="off" v-model="name"></el-input>
        </el-form-item>
        <!-- FORENAME -->
        <el-form-item prop="forename" :label="$t.__('common.labels.first_name')">
            <el-input name="firstname" autocomplete="off" v-model="forename"></el-input>
        </el-form-item>

        <!-- TYPE -->
        <el-form-item prop="type" :label="$t.__('common.labels.type')">
            <el-select v-model="type" class="wp-10" :disabled="typeDisabled">
                <el-option
                    v-for="option in typeList"
                    :key="option.label"
                    :value="option"
                    :label="tagsHuman[option].label"
                />
            </el-select>
        </el-form-item>
    </section>
</template>

<script>
import TagHumansConfig from 'Config/authenticated/TagHumans';

export default {
    props: {
        currentStore: {
            type: String,
            required: true,
        },
    },
    created() {
        //if contact is a fetched contact from slsy, then format their civility infos
        this.$store.dispatch(`${this.currentStore}/fetchThirdMetadata`, 'individuals').then(() => {
            if (!_.isNil(this.civility)) {
                if (typeof this.civility === 'string') {
                    let currentCivility = '';
                    for (let i = 0; i < this.civilities.length; i++) {
                        if (this.civilities[i].value === this.civility) {
                            currentCivility = this.civilities[i].label;
                            break;
                        }
                    }
                    this.$store.commit(`${this.currentStore}/setCivility`, currentCivility);
                }
            } else {
                this.$store.commit(
                    `${this.currentStore}/setCivility`,
                    this.civilities.find((civility) => civility.value === 'mr'),
                );
            }
        });
    },
    computed: {
        //CIVILITIES
        civilities() {
            return this.$store.getters[`${this.currentStore}/getCivilities`];
        },
        civility: {
            get() {
                return this.$store.getters[`${this.currentStore}/getCivility`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setCivility`, value);
            },
        },

        //NAMES
        name: {
            get() {
                return this.$store.getters[`${this.currentStore}/getName`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setName`, value);
            },
        },
        forename: {
            get() {
                return this.$store.getters[`${this.currentStore}/getForename`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setForename`, value);
            },
        },

        // TYPE
        tagsHuman() {
            return TagHumansConfig;
        },
        typeDisabled() {
            return !_.isNil(this.$store.getters[`${this.currentStore}/getId`]);
        },
        type: {
            get() {
                return this.$store.getters[`${this.currentStore}/getType`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setType`, value);
                this.$emit('change-type', value);
            },
        },
        typeList() {
            return this.$store.getters[`${this.currentStore}/getTypes`];
        },
    },
};
</script>

<style></style>
